/**
 * Enum loại backup
 * nmtuan4 8.3.2023
 */
export default {
  Backup: 0, // Sao lưu
  Store: 1, // Lưu trữ
};
